<template>
    <div class="booths">
        <template v-for="(booth, index) in booths">
            <div :key="index" class="booth" :id="'booth_'+booth.id">
                <div class="intro" @click="openBooth(booth.id)">
                    <div class="preTitle">
                        <h4 class="name">Défipix {{ booth.name }}</h4>
                    </div>
                </div>
                <div class="detail" :id="'detail_'+booth.id">
                    <p class="descBooth" v-html=booth.long_description />
                    <img :id="'chevron_'+booth.id" class="illusBooth" :alt='"illustration of Défipix "+booth.name' :src="'https://preprod.api.defipix.fr/ressource/booth/picture/'+booth.name+'.png'" />
                </div>
                <Gallery :imageArray="booth.imageArray" :idBooth="booth.id" />
            </div>
        </template>
    </div>
</template>

<script>

import JQuery from 'jquery';
let $ = JQuery;
import Gallery from './Gallery';

export default {
    data() {
        return {
            boothSelected: null,
        }
    },
    updated: function() {
        this.openBooth();
    },
    props: {
        booths: Array,
    },
    components: {
        Gallery,
    },
    methods: {
        openBooth(id) {
            id ? id = id : id = this.$route.query.id;
            if (id != 1) {
                $('html, body').animate({
                    scrollTop: parseInt($("#booth_" + id).offset().top*1.3)
                }, 1000);
            }
            this.boothSelected = parseInt(id);
        }
    }
}
</script>

<style scoped>
.booths {
    display: grid;
    grid-template-columns: 100%;
    margin: auto;
}

.booth {
    padding: 1em;
    margin: 1em auto;
    width: 100%;
    background-color: #25327B;
    box-shadow: 0px 0px 5px 0px #aaa;
    border-radius: 5px;
    position: relative;
    color: #fff;
}

.intro {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 1em 0;
}

.detail {
    display: grid;
    padding: 1em;
    grid-template-columns: 70% 30%;
}

.preTitle {
    margin: 0 0 0 1em;
}

.name {
    grid-area: title;
    padding: 0;
    margin: 0;
}

.illusBooth {
    width: 100%;
}

.chevron {
    position: absolute;
    width: 1.5em;
    right: 1em;
    top: 1.5em;
}

.chevron:hover {
    cursor: pointer;
}

@media only screen and (max-width: 765px) {
    .preTitle {
        margin: 0;
    }

    .detail {
        padding: unset;
        grid-template-columns: 100%;
    }
}

@media only screen and (max-width: 575px) {
    .nameOpt {
        max-width: 90%;
    }
}

@media only screen and (max-width: 450px) {
    .nameOpt {
        font-size: 18px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Booths/List.vue